import { render, staticRenderFns } from "./ServiceScheduleTutorDeleteShift.vue?vue&type=template&id=2bc63314&"
import script from "./ServiceScheduleTutorDeleteShift.vue?vue&type=script&lang=js&"
export * from "./ServiceScheduleTutorDeleteShift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports